import { useRouter } from 'next/router';
import { IoCloseCircle } from 'react-icons/io5';
import { addHistorySearch } from '../../common/search/addHistorySearchLocal';
import { PATH_NAME } from '../../configs/pathName';
import { SEARCH_QUERY } from '../../constant/queryURLKey';
import { ISearchInput } from '../../interfaces/components/input.interface';

const SearchInput: React.FC<ISearchInput> = ({
  className,
  icon,
  name,
  isObject,
  setValue,
  value,
  placeholder,
  onFocus = () => {},
  redirectAfterClear,
  callBackAfterSubmit
}) => {
  const router = useRouter();

  const handleClearSearchInput = () => {
    setValue('');
    redirectAfterClear && router.replace(redirectAfterClear);
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (value.trim().length === 0) return;
        addHistorySearch(value);
        // router.push(`${PATH_NAME.SEARCH}?${SEARCH_QUERY}=${value}`);
        callBackAfterSubmit && callBackAfterSubmit();
      }}
      onClick={(e) => e.preventDefault()}
      className={`bg-white px-2 border border-[#e2e2e2] focus-within:border-sky-500 rounded-lg flex items-center justify-start gap-2 relative ${className}`}
    >
      <p className="p-1 rounded-lg opacity-40">{icon}</p>
      <input
        onFocus={onFocus}
        maxLength={256}
        name={name || ''}
        onChange={(e) => {
          isObject
            ? setValue(e.target.name, e.target.value)
            : setValue(e.target.value);
        }}
        className={` focus:outline-none py-2 flex-1 rounded-lg ${
          value == '' ? 'text-grey_2' : 'text-black'
        }`}
        placeholder={placeholder}
        value={value}
      />
      {value && (
        <IoCloseCircle
          onClick={handleClearSearchInput}
          color="#979797"
          className="cursor-pointer"
        />
      )}
    </form>
  );
};

export default SearchInput;
